import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Dynamic%20sports%20arena%20atmosphere%20with%20dramatic%20stadium%20floodlights%2C%20dark%20moody%20background%20with%20warm%20golden%20light%20beams%2C%20athletic%20silhouettes%20in%20motion%2C%20professional%20sports%20photography%20style%2C%20abstract%20motion%20blur%2C%20epic%20cinematic%20lighting%2C%20dark%20navy%20and%20crimson%20tones%2C%20no%20text%20or%20logos&width=1800&height=900&seq=hero-bb-sports&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-accent-300 text-sm font-medium">多场热门赛事正在进行中</span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-5 tracking-tight">
            专业体育赛事服务
            <br />
            <span className="text-primary-400">就在BB体育</span>
          </h1>

          <p className="text-background-200/90 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            BB体育是您首选的专业体育服务平台，涵盖足球、篮球、网球、电竞等多项热门赛事，
            提供实时数据、精彩赛事直播与深度体育资讯。注册即享专属福利，立即加入BB体育大家庭。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即注册
            </Link>
            <Link
              to="/category/zuqiu"
              className="px-8 py-3 rounded-lg bg-background-50/15 text-background-50 font-medium text-base border border-background-50/30 hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              浏览赛事
            </Link>
          </div>

          <div className="grid grid-cols-3 gap-6 md:gap-10 mt-14 max-w-lg mx-auto">
            {[
              { value: '200+', label: '覆盖赛事' },
              { value: '50万+', label: '活跃用户' },
              { value: '24/7', label: '实时更新' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-400">
                  {stat.value}
                </div>
                <div className="text-background-300/80 text-xs md:text-sm mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}